export default __webpack_public_path__ + "static/media/VikashVijay.6f3ea5ea.webp";